import { Nullable } from '../Shared/Types';

export enum MedicationListStatus {
    Draft = 'draft',
    Published = 'published'
}

export enum MedicationListType {
    ScopeOfPracticeList = 'scopeOfPracticeList',
    Formulary = 'formulary',
    DefaultList = 'defaultList'
}

export interface MedicationListsSearchFilter {
    status: Nullable<MedicationListStatus>;
    types: MedicationListType[];
}
